// Display-only INR formatting. Values from the server are never changed;
// they are only rounded to 2 decimals for display, Indian digit grouping.
//   formatINR(1770)      -> "₹1,770.00"
//   formatINR("102.377") -> "₹102.38"
//   formatINR(0)         -> "₹0.00"
//   formatINR(null)      -> "—"

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const inrNumberFormatter = new Intl.NumberFormat("en-IN", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = typeof value === "number" ? value : Number(String(value).replace(/,/g, ""));
  return Number.isFinite(n) ? n : NaN;
};

export const formatINR = (value, empty = "—") => {
  const n = toNumber(value);
  if (n === null) return empty;
  if (Number.isNaN(n)) return String(value);
  return inrFormatter.format(n);
};

// same as formatINR but without the ₹ symbol, for places where a label or icon already shows it
export const formatINRNumber = (value, empty = "—") => {
  const n = toNumber(value);
  if (n === null) return empty;
  if (Number.isNaN(n)) return String(value);
  return inrNumberFormatter.format(n);
};
